export default "__VITE_ASSET__CBEBvTIC__"